import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import { Button, ButtonToolbar, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import TicketInput from '../../components/TicketInput';


const propTypes = exact({
  onComplete: PropTypes.func.isRequired,
  ticketNumbers: PropTypes.array.isRequired,
  item: PropTypes.object.isRequired,
  createTicketAttachment: PropTypes.func.isRequired,
});


class TicketAttachmentEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketNumber: null,
      description: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleComplete = this.handleComplete.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  async handleComplete() {
    const { item, onComplete, createTicketAttachment } = this.props;
    const { ticketNumber, description } = this.state;


    const variables = {
      input: {
        description,
        submission_item_id: item.id,
        ticket_number_id: ticketNumber.id,
      },
    };

    await createTicketAttachment({ variables });
    await onComplete(item);
  }

  isValid() {
    const { description, ticketNumber } = this.state;
    return description !== '' && ticketNumber !== null;
  }

  render() {
    const { ticketNumbers } = this.props;
    const { ticketNumber, description } = this.state;
    const createdTicketNumbers = ticketNumbers.join(', ');
    return (
      <div>
        <div className="panel panel-default">
          <div className="panel-body">
            <FormGroup>
              <div>
                <ControlLabel>Ticket Numbers:</ControlLabel>
                {createdTicketNumbers}
              </div>
              <ControlLabel>Description</ControlLabel>
              <FormControl
                name="description"
                type="text"
                value={description}
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Ticket</ControlLabel>
              <TicketInput
                name="ticketNumber"
                onChange={this.handleChange}
                assigned="attachable"
                value={ticketNumber}
              />
            </FormGroup>
          </div>
        </div>
        <ButtonToolbar>
          <Button
            className="pull-right"
            bsStyle="primary"
            onClick={this.handleComplete}
            disabled={!this.isValid()}
          >
            Complete
          </Button>
        </ButtonToolbar>
      </div>
    );
  }
}


const CreateTicketAttachmentMutation = gql`
  mutation CreateTicketAttachment($input: TicketAttachmentCreateInput!) {
    ticket_attachment_create(input: $input) {
      id
    }
  }
`;


TicketAttachmentEditor.propTypes = propTypes;


const withApi = compose(graphql(CreateTicketAttachmentMutation, { name: 'createTicketAttachment' }));


export default withApi(TicketAttachmentEditor);
